import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { TemplatesCollectionEligibleQuery } from './TemplatesCollectionEligibleQuery.graphql.ts';

export const preloadTemplatesCollectionEligible = () =>
	query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: TemplatesCollectionEligibleQuery,
	});
